// IDI-656 D3: Settings → Branding's logo rules, shared with onboarding's
// Your Business step so both accept the same files and say the same things.
export { LOGO_RESIZE_FAILED } from './prepareLogo';

export const LOGO_ACCEPT = 'image/png,image/jpeg,image/svg+xml';
export const LOGO_MAX_BYTES = 2 * 1024 * 1024; // 2 MB
export const LOGO_HINT = 'PNG · JPG · SVG · up to 2 MB.';
export const LOGO_TOO_LARGE = 'Logo file exceeds the 2 MB size cap.';
